import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TSliceInterpreterScript = {
  data: string;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
  lastFetchedAt: string | null;
};

const initialState: TSliceInterpreterScript = {
  data: "",
  isLoading: false,
  isLoaded: false,
  error: null,
  lastFetchedAt: null,
};

const sliceInterpreterScript = createSlice({
  name: "sliceInterpreterScript",
  initialState,
  reducers: {
    FetchStart: (state): TSliceInterpreterScript => ({
      ...state,
      isLoading: true,
      error: null,
    }),
    FetchSuccess: (state, action: PayloadAction<string>): TSliceInterpreterScript => ({
      ...state,
      data: action.payload,
      isLoading: false,
      isLoaded: true,
      error: null,
      lastFetchedAt: new Date().toISOString(),
    }),
    FetchFailure: (state, action: PayloadAction<string | null | undefined>): TSliceInterpreterScript => ({
      ...state,
      isLoading: false,
      isLoaded: false,
      error: action.payload ?? "Failed to load interpreter script.",
    }),
    Clear: (): TSliceInterpreterScript => initialState,
  },
});

export const ReducerInterpreterScript = sliceInterpreterScript.reducer;
export const ActionInterpreterScript = sliceInterpreterScript.actions;
